import { Injectable } from '@angular/core';

/**
 * The one place the app asks the browser for a full page load. A full load
 * rebuilds every in-memory singleton, which in-app routing does not. Specs
 * replace this service, because Karma cannot survive a real page load.
 */
@Injectable({ providedIn: 'root' })
export class PageLoadService {
  /** Loads `path` as a new page, discarding the running app. */
  load(path: string): void {
    window.location.assign(path);
  }
}
